// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league_match_player_show_assistance_general .modal2__container{
    width: 75%;
}


.league_match_player__show_assistance-container {
    display: flex;
    align-items: flex-start;
    gap: var(--space);
    padding: var(--space-x2);
}

.league_match_player__show_assistance-section {
    background: var(--white-color);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 8px;
    width: 50%;
    height: 550px;
}

.league_match_player__show_assistance-general-box{
    margin: var(--space);
}

.league_match_player__show_assistance-team {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--space-half);
    padding: var(--space-half);
    border: 1.5px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.league_match_team_assistance_section-team_photo{
    width: 40px;
    border-radius: 50%;
}

.league_match_team_assistance_team-ball-photo .icon-ball{
    color: var(--white-color );
    font-size: 40px;
    border-radius: 50%;
    padding: 3px;
}

.league_match_team_assistance_section-team_names .baloa-table{
    font-weight: var(--font-medium);
    color: var(--primary-very-dark-color);
}

.league_match_team_assistance_section-team_names .baloa-mini{
    color: var(--primary-dark-color);
}

.league_match_player__show_assistance-players{
    margin-left: var(--space);
    overflow-y: scroll;
    height: 450px;
}

.league_match_player__show_assistance-players-title-section{
    margin: var(--space-half) 0;
}

.league_match_player__show_assistance_players-substitute,
.league_match_player__show_assistance_players-others {
    display: flex;
    flex-direction: column;
    gap: var(--space-half);
    margin-top: var(--space);
}

.league_match_player__show_assistance-players-title-section.baloa-username{
    font-weight: var(--font-medium);
    color: var(--primary-dark-color);
}

.league_match_player__show_assistance_players-titular{
    display: flex;
    flex-direction: column;
    gap: var(--space-half);
    margin-top: var(--space);
}

.league_match_player__show_assistance_player-information {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--space-half);
}

.league_match_player__show-member_photo{
    width: 40px;
    border-radius: 50%;
}

.league_match_player__show_section--photo .icon-ball{
    color: var(--white-color );
    font-size: 40px;
    border-radius: 50%;
    padding: 3px;
}

.league_match_player__assistance_section-player_name .baloa-table{
    font-weight: var(--font-medium);
    color: var(--primary-dark-color);
}

.league_match_player__assistance_section-player_name .baloa-mini{
    color: var(--basic-gray-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-match-player-show-assistant-modal/LeagueMatchPlayerShowAssistantModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,oDAAoD;IACpD,kBAAkB;IAClB,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,0BAA0B;IAC1B,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".league_match_player_show_assistance_general .modal2__container{\n    width: 75%;\n}\n\n\n.league_match_player__show_assistance-container {\n    display: flex;\n    align-items: flex-start;\n    gap: var(--space);\n    padding: var(--space-x2);\n}\n\n.league_match_player__show_assistance-section {\n    background: var(--white-color);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    width: 50%;\n    height: 550px;\n}\n\n.league_match_player__show_assistance-general-box{\n    margin: var(--space);\n}\n\n.league_match_player__show_assistance-team {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: var(--space-half);\n    padding: var(--space-half);\n    border: 1.5px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.league_match_team_assistance_section-team_photo{\n    width: 40px;\n    border-radius: 50%;\n}\n\n.league_match_team_assistance_team-ball-photo .icon-ball{\n    color: var(--white-color );\n    font-size: 40px;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.league_match_team_assistance_section-team_names .baloa-table{\n    font-weight: var(--font-medium);\n    color: var(--primary-very-dark-color);\n}\n\n.league_match_team_assistance_section-team_names .baloa-mini{\n    color: var(--primary-dark-color);\n}\n\n.league_match_player__show_assistance-players{\n    margin-left: var(--space);\n    overflow-y: scroll;\n    height: 450px;\n}\n\n.league_match_player__show_assistance-players-title-section{\n    margin: var(--space-half) 0;\n}\n\n.league_match_player__show_assistance_players-substitute,\n.league_match_player__show_assistance_players-others {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-half);\n    margin-top: var(--space);\n}\n\n.league_match_player__show_assistance-players-title-section.baloa-username{\n    font-weight: var(--font-medium);\n    color: var(--primary-dark-color);\n}\n\n.league_match_player__show_assistance_players-titular{\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-half);\n    margin-top: var(--space);\n}\n\n.league_match_player__show_assistance_player-information {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: var(--space-half);\n}\n\n.league_match_player__show-member_photo{\n    width: 40px;\n    border-radius: 50%;\n}\n\n.league_match_player__show_section--photo .icon-ball{\n    color: var(--white-color );\n    font-size: 40px;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.league_match_player__assistance_section-player_name .baloa-table{\n    font-weight: var(--font-medium);\n    color: var(--primary-dark-color);\n}\n\n.league_match_player__assistance_section-player_name .baloa-mini{\n    color: var(--basic-gray-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
